var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLine = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.502 4.443a.75.75 0 0 1 .055 1.059l-4.5 5a.75.75 0 0 1-.862.183l-3.99-1.773-2.636 3.076a.75.75 0 1 1-1.138-.976l3-3.5a.75.75 0 0 1 .874-.197l4.002 1.778 4.136-4.595a.75.75 0 0 1 1.059-.055z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLine);
export default ForwardRef;